import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

export const reloadOnClusterDataChange = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    ec.models.CollectionProducer.getEc$(ec.Name.Predefined.SpaceCluster, {
      waitUntilReady: true,
    }).pipe(
      rxjs.switchMap(clustersEc =>
        clustersEc.plugins.editingPlugin.feature.actions.submit.success
          .observe()
          .pipe(
            rxjs.map(() =>
              collection.plugins.currentListPlugin.feature.actions.load
                .from('(effect) reload on cluster data change')
                .create(),
            ),
          ),
      ),
    ),
)
